import appConfig from "../config/app.config";
import axios from "axios";
import { getUserToken } from "../libs/user";
import {
  getPureJSON,
  handleError,
  startLoader,
  stopLoader,
} from "../libs/utils";

const getActiveOffers = () => {
  startLoader();
  return new Promise((resolve, reject) => {
    var config = {
      method: "get",
      url: appConfig.apiUrl.getActiveOffers,
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
      },
    };

    axios(config)
      .then(function (response) {
        stopLoader();
        resolve(response.data);
      })
      .catch(function (error) {
        stopLoader();
        handleError({ error, reject });
      });
  });
};

const giveCashbackToUser = (obj) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify(obj);

    const config = {
      method: "post",
      url: appConfig.apiUrl.giveCashback,
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        handleError({ error, reject });
      });
  });
};
export { getActiveOffers, giveCashbackToUser };
